import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  IN_ROOM_DINING_ITEMS_VIEW,
  IN_ROOM_DINING_ITEMS_CREATE,
  IN_ROOM_DINING_ITEMS_EDIT,
  IN_ROOM_DINING_ITEMS_FILTER,
  IN_ROOM_DINING_ITEMS_FILTER_TYPE_SUBMENU,
  IN_ROOM_DINING_ITEMS_FILTER_STATUS_SUBMENU,
  IN_ROOM_DINING_COMBO_ADDONS_GROUPED,
  IN_ROOM_DINING_COMBO_ADDONS_INACTIVE,
  IN_ROOM_DINING_COMBO_ADDONS_UNGROUPED,
} from '../../../../../constants/InRoomDiningConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_IN_ROOM_DINING,
} from '../../../../../constants/RoleConsts';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import SearchBar from '../../../../../shared/search-bar/Search-Bar';
import {
  inRoomDiningItemsSelector,
  fetchAllInRoomDining,
  inRoomDiningKindsSelector,
  inRoomDiningMenuSelector,
  inRoomDiningCombosSelector,
  setInRoomDiningItems,
  inRoomDiningAddOnSelector,
  inRoomDiningTagsSelector,
  inRoomDiningAllergensSelector,
  inRoomDiningCustomisationsSelector,
  inRoomDiningDiscountsSelector,
} from '../../../servicesSlice';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import { AddCircle, DragIndicator, MoreHoriz } from '@material-ui/icons';
import CustomChip from '../../../../../shared/form-controls/custom-chip/Custom-Chip';
import {
  deleteInRoomDiningItem,
  activateInRoomDiningItem,
  deactivateInRoomDiningItem,
  uploadIRDItemByCSV,
  updateSelectedItemsStatus,
  deleteSelectedItems,
} from '../../../../../utils/ServicesAPIUtils';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
  Menu,
  MenuItem,
  Checkbox,
} from '@material-ui/core';
import CreateIcon from '@material-ui/icons/Create';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import VisibilityIcon from '@mui/icons-material/Visibility';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import {
  allHotelsSelector,
  selectedHotelCurrencySelector,
} from '../../../../property/propertySlice';
import WarningPopup from '../../../../../shared/warning-popup/Warning-Popup';
import useOutsideAlerter from '../../../../../custom-hooks/useOutsideAlerter';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { handleOnDragEnd } from '../../../../../shared/custom-dragdrop/dragDrop';
import { createDataSortMapping } from '../../../../../utils/PropertyAPIUtils';
import {
  getCheckedIds,
  updateCheckedStatus,
  updateSelectedModule,
  validateAlphanumeric,
  generateConfirmationMessage,
  selectedCheckList,
  ResetFilterList,
  PARTIAL_CHECKBOX_GREEN,
  isDragDisabled,
} from '../../../../../utils/formUtils';
import { Dialog } from '@mui/material';
import CsvUploader from '../../../../../shared/csv-uploader/Csv-Uploader';
import MultipleDeleteConfirmationPopup from '../../../../../shared/MultiActionPopUp/MultiDeleteConfirmationPopup';
import MultipleSelectionAlert from '../../../../../shared/MultiActionPopUp/MultipleSelectionAlert';
import BulkActionCheckBox from '../../../../../shared/MultiActionPopUp/BulkActionCheckBox';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { DOWNLOAD_ASSETS_URL } from '../../../../../env/Configurations';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const ItemsListView = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    hotelId,
    restaurantId,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
    isHideAddButton = false,
  } = props;

  const selectedHotel = useSelector(allHotelsSelector);
  const inRoomDiningItems = useSelector(inRoomDiningItemsSelector);
  const inRoomDiningCombos = useSelector(inRoomDiningCombosSelector);
  const inRoomDiningKinds = useSelector(inRoomDiningKindsSelector);
  const inRoomDiningMenu = useSelector(inRoomDiningMenuSelector);
  const originalAddons = useSelector(inRoomDiningAddOnSelector);
  const originalTags = useSelector(inRoomDiningTagsSelector);
  const originalAllergens = useSelector(inRoomDiningAllergensSelector);
  const originalCustomisations = useSelector(inRoomDiningCustomisationsSelector);
  const originalDiscounts = useSelector(inRoomDiningDiscountsSelector);
  const currency = useSelector(selectedHotelCurrencySelector);
  const dispatch = useDispatch();
  const [itemsList, setItemsList] = useState([]);
  const [filteredBaseList, setFilteredBaseList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterDataList, setFilterDataList] = useState([]);
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    warn: false,
    anchorEl: null,
  });
  const [visible, setVisible] = useState(false);
  const wrapperRef = useRef(null);
  const prevHotelIdRef = useRef(hotelId);
  const [popUp, setPopUp] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [uploadState, setUploadState] = useState(false);
  const [csvUploadStatus, setCsvUploadStatus] = useState(false);
  const [csvUploadErrorMsg, setCsvUploadErrorMsg] = useState(null);
  const [csvValidateError, setCsvValidateError] = useState(false);
  const [dataExistError, setDataExistError] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [actionMenuList, setActionMenuList] = useState([]);
  const [actionName, setActionName] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [showMultipleDeleteConfirmation, setShowMultipleDeleteConfirmation] = useState(false);
  const [showBulkActiveDeactiveConfirmation, setShowBulkActiveDeactiveConfirmation] =
    useState(false);
  const [showBulkSearchAlert, setShowBulkSearchAlert] = useState(false);
  const [showBulkKebabSelectionAlert, setShowBulkKebabSelectionAlert] = useState(false);
  const [showBulkFilterAlert, setShowBulkFilterAlert] = useState(false);
  const [dragEnabled, setDragEnabled] = useState(true);

  useEffect(() => {
    setFilterDataList(IN_ROOM_DINING_ITEMS_FILTER);
  }, []);

  useEffect(() => {
    const withCheck = inRoomDiningItems?.map((item) => {
      const isChecked = selectedCheckList(itemsList, item.id);
      return {
        ...item,
        isChecked,
      };
    });
    setItemsList(withCheck);
    setFilteredBaseList(withCheck);
    setLoading(false);
    setSearchText('');
    resetFilterDataList();
  }, [inRoomDiningItems]);

  const getCheckedItemList = itemsList?.filter((discount) => discount?.isChecked);

  const listOfItemIds = getCheckedItemList?.map((discount) => discount.id);

  const selectedDiscountLength = getCheckedItemList?.length;

  const handleSearchText = async (searchText) => {
    setSearchText(searchText);
    const checkedIdList = getCheckedIds(itemsList, 'isChecked');
    const filteredRows = await filteredBaseList.filter((item) => {
      return (
        item.name.toLowerCase().includes(searchText.toLowerCase()) ||
        item.type.toLowerCase().includes(searchText.toLowerCase())
      );
    });
    const updatedCheckedList = updateCheckedStatus(filteredRows, checkedIdList);
    onsetPage(0);
    setItemsList(updatedCheckedList);
    if (searchText && (isAllSelected || selectedDiscountLength > 0)) {
      setShowBulkSearchAlert(true);
    } else if (!searchText) {
      setShowBulkSearchAlert(false);
      setItemsList(filteredBaseList);
    }
  };

  const dragDisabled = !dragEnabled || itemsList?.length <= 1;

  const onOpenDrawer = (event, type) => {
    if (selectedDiscountLength) {
      setItemsList(ResetFilterList);
    }
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.item);
    handleClose();
  };

  const onViewDetailsFromMenu = (e) => {
    if (selectedValue?.item) onViewToggle(IN_ROOM_DINING_ITEMS_VIEW, true, selectedValue?.item);
  };

  const onViewDetails = (itemKey, e) => {
    if (e?.target?.tagName === 'TD') {
      onViewToggle(IN_ROOM_DINING_ITEMS_VIEW, true, itemKey);
    }
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      warn: false,
      anchorEl: null,
      item: null,
    });
  };

  const handleCellMenuClick = (event, item) => {
    if (selectedDiscountLength > 1) {
      setShowBulkKebabSelectionAlert(true);
    } else {
      setSelectedValue({
        id: item.id,
        name: item.name,
        title: '',
        description: '',
        status: false,
        warn: false,
        anchorEl: event.currentTarget,
        item,
      });
    }
  };
  const handleBulkSearchAlertClose = () => {
    setShowBulkSearchAlert(false);
    setSearchText('');
    setItemsList(
      inRoomDiningItems?.map((res) => ({
        ...res,
        isChecked: false,
      })),
    );
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const checkUsageInCategories = () => {
    return inRoomDiningMenu.some((ird) =>
      ird.categories.some((category) =>
        category.items.some((item) => item.id === selectedValue.id),
      ),
    );
  };

  const checkUsageInSubCategories = () => {
    return inRoomDiningMenu.some((ird) =>
      ird.categories.some((category) =>
        category.subCategories.some((subCategory) =>
          subCategory.items.some((item) => item.id === selectedValue.id),
        ),
      ),
    );
  };

  const checkUsageInUpsellItems = () => {
    return inRoomDiningItems.some(
      (ird) => ird.upsell.items && ird.upsell.items.some((item) => item === selectedValue.id),
    );
  };

  const checkUsageInUpsellCombos = () => {
    return inRoomDiningCombos.some(
      (ird) => ird.upsell.items && ird.upsell.items.some((item) => item === selectedValue.id),
    );
  };

  const onClickDelete = (event) => {
    if (
      checkUsageInCategories() ||
      checkUsageInSubCategories() ||
      checkUsageInUpsellItems() ||
      checkUsageInUpsellCombos()
    ) {
      setSelectedValue((prev) => ({
        ...prev,
        title: 'Are you sure you want to delete',
        description:
          'The selected Item cannot be deleted as it is being added to a Menu/Combo/Item',
        status: false,
        warn: true,
        anchorEl: null,
      }));
    } else {
      setSelectedValue((prev) => ({
        ...prev,
        title: 'Are you sure you want to delete',
        description: 'This action cannot be reversed',
        status: true,
        warn: false,
        anchorEl: null,
      }));
    }
  };

  const onDeleteItem = async () => {
    resetFilterDataList();
    try {
      dispatch(stepUpLoaderCount());
      if (hotelId && selectedValue.id) {
        const selectedLanguage = decryptLocalStorage('lang');
        const language = selectedLanguage !== 'en' ? selectedLanguage : '';
        const payload = {
          id: selectedValue.id,
          hotelId: hotelId,
          restaurantId: restaurantId,
        };
        await deleteInRoomDiningItem(payload, language);
        dispatch(fetchAllInRoomDining(hotelId, restaurantId));
        notificationManager('success', 'Item deleted successfully');
      }
      handleClose();
    } catch (e) {
      if (e.graphQLErrors) {
        notificationManager('danger', e.graphQLErrors[0].message);
      } else {
        notificationManager('danger', 'Failed to delete Item');
      }
    } finally {
      dispatch(stepDownLoaderCount());
    }
    handleClose();
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const onDeleteCancel = (event) => {
    handleClose();
  };

  const onToggleStatus = async (e) => {
    resetFilterDataList();
    if (selectedValue.item && hotelId) {
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      try {
        dispatch(stepUpLoaderCount());
        const payload = {
          id: selectedValue.item.id,
          hotelId: hotelId,
          restaurantId: restaurantId,
        };
        selectedValue.item.status
          ? await deactivateInRoomDiningItem(payload, language)
          : await activateInRoomDiningItem(payload, language);
        dispatch(fetchAllInRoomDining(hotelId, restaurantId));
        notificationManager(
          'success',
          `Item ${selectedValue.item.status ? 'deactivated' : 'activated'} successfully`,
        );
      } catch (e) {
        if (e.graphQLErrors) {
          notificationManager('danger', e.graphQLErrors[0].message);
        } else {
          notificationManager('danger', 'Failed to update Item Status');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
    handleClose();
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const resetFilterDataList = () => {
    IN_ROOM_DINING_ITEMS_FILTER[1].subMenu = IN_ROOM_DINING_ITEMS_FILTER_TYPE_SUBMENU;
    IN_ROOM_DINING_ITEMS_FILTER[2].subMenu = IN_ROOM_DINING_ITEMS_FILTER_STATUS_SUBMENU;
    setFilterDataList(IN_ROOM_DINING_ITEMS_FILTER);
  };

  useEffect(() => {
    resetFilterDataList();
  }, []);

  const filteredRecords = (filters, field) => {
    if (field === 'all') {
      setFilteredBaseList(inRoomDiningItems);
      setItemsList(inRoomDiningItems);
      resetFilterDataList();
    } else {
      const filterIdWithFields = filterDataList
        .filter((initialFilter) => initialFilter.subMenu.length > 0)
        .map((filterItem) => {
          const subMenuFiltersId = filterItem.subMenu
            .filter((fItem) => fItem.selected === true)
            .map((fItemId) => fItemId.id);
          if (subMenuFiltersId.length > 0) {
            return {
              id: subMenuFiltersId,
              field: filterItem.field,
            };
          } else return null;
        })
        .filter((item) => item !== null);
      const filteredRecords = inRoomDiningItems.filter((treatment) => {
        const doesFilterSatisfy = filterIdWithFields.map((filter) =>
          filter.id.includes(treatment[filter.field]),
        );
        return !doesFilterSatisfy.includes(false);
      });
      onsetPage(0);
      setFilteredBaseList(filteredRecords);
      setItemsList(filteredRecords);
    }
  };

  const getItemType = (typeId) => {
    return inRoomDiningKinds.find((kind) => kind.id === typeId)?.name ?? '';
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);

  const handleUploadDialogClose = (e) => {
    dispatch(fetchAllInRoomDining(hotelId, restaurantId));
    setCsvUploadStatus(null);
    setUploadState(false);
  };
  const onClickUpload = (e) => {
    setUploadState(true);
  };
  const normalizeNumber = (s) => {
    const digits = String(s ?? '')?.replace(/[^\d]/g, '');
    return digits ? parseInt(digits, 10) : NaN;
  };
  const isValidStatus = (status) => {
    const v = (status || '')?.toString()?.trim()?.toLowerCase();
    return ['yes', 'no', 'active', 'inactive', 'true', 'false', 'y', 'n', '1', '0'].includes(v);
  };

  const isAvailable = (data, originalItem) => {
    const convertedItems = originalItem && originalItem.map((x) => x.name.toLowerCase());
    const containsAll = data?.every((element) => {
      return convertedItems.includes(element.toLowerCase().trim());
    });
    return containsAll;
  };

  let findDuplicates = (arr) => arr.filter((item, index) => arr.indexOf(item) !== index);

  const validateAddOns = (type, addon) => {
    const t = (type || '').toString().trim().toLowerCase();
    const a = (addon || '').toString().trim();
    if (!t || t === 'inactive') return false;
    if (t === 'grouped') {
      if (!a) return true;
      const groups = a
        .split('/')
        .map((s) => s.trim())
        .filter(Boolean);
      if (groups.length === 0) return true;
      for (const g of groups) {
        const parts = g.split('-');
        if (parts.length !== 3) return true;
        const [title, limitStr, listStr] = parts;

        if (!title || !validateAlphanumeric(title)) return true;
        if (!limitStr || isNaN(+limitStr)) return true;
        const wanted = toLowerSet(
          (listStr || '')
            .split(',')
            .map((s) => s.trim())
            .filter(Boolean),
        );
        if (wanted.size !== +limitStr) return true;
        const actual = toLowerSet(originalAddons?.map((x) => x.name));
        for (const n of wanted) if (!actual.has(n)) return true;
        if (wanted.size !== (listStr || '').split(',').length) return true;
      }
      return false;
    }

    if (t === 'ungrouped') {
      if (!a) return true;

      if (a.includes('-')) {
        const parts = a.split('-');
        if (parts.length !== 2) return true;
        const [limitStr, listStr] = parts;

        if (!limitStr || isNaN(+limitStr)) return true;
        const wantedArr = (listStr || '')
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean);
        const wanted = toLowerSet(wantedArr);
        if (wanted.size !== +limitStr) return true;

        const actual = toLowerSet(originalAddons?.map((x) => x.name));
        for (const n of wanted) if (!actual.has(n)) return true;
        if (wanted.size !== wantedArr.length) return true;
        return false;
      } else {
        const wantedArr = a
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean);
        if (wantedArr.length === 0) return true;
        const wanted = toLowerSet(wantedArr);
        const actual = toLowerSet(originalAddons?.map((x) => x.name));
        for (const n of wanted) if (!actual.has(n)) return true;
        if (wanted.size !== wantedArr.length) return true;
        return false;
      }
    }

    return true;
  };

  const validateCustomizationGroups = (groups) => {
    if (!groups || groups.length === 0) return false;
    const actual = toLowerSet(originalCustomisations?.map((x) => x.name));

    for (const g of groups) {
      const parts = (g || '').split('-');
      if (parts.length !== 2) return true;
      const [ingredient, listStr] = parts.map((s) => (s || '').trim());
      if (!ingredient || ingredient.length > 100 || !validateAlphanumeric(ingredient)) return true;

      const namesArr = (listStr || '')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean);
      const names = toLowerSet(namesArr);
      if (names.size !== namesArr.length) return true;
      for (const n of names) if (!actual.has(n)) return true;
    }
    return false;
  };

  const validateCustomizations = (data) => {
    const generateGroupedArray = data?.split('/');
    const isValid = generateGroupedArray.every((item) => {
      if (!item) {
        return false;
      } else {
        const tempAddon = item?.split('-');
        if (tempAddon.length !== 2) {
          return false;
        } else {
          return (
            tempAddon[0].length > 1 &&
            tempAddon[0].length <= 100 &&
            validateAlphanumeric(tempAddon[0]) &&
            tempAddon[1] &&
            findDuplicates(tempAddon[1]?.split(',')).length === 0 &&
            isAvailable(tempAddon[1]?.split(','), originalCustomisations)
          );
        }
      }
    });
    return !isValid;
  };

  const isNumber = (n) => {
    return !isNaN(parseFloat(n)) && !isNaN(n - 0);
  };

  const truthyWord = (v) =>
    ['yes', 'active', 'true', 'y', '1'].includes((v || '').toString().trim().toLowerCase());
  const falsyWord = (v) =>
    ['no', 'inactive', 'false', 'n', '0'].includes((v || '').toString().trim().toLowerCase());
  const asBooleanOrList = (raw) => {
    const s = (raw || '').toString().trim();
    if (!s) return { active: false, names: [] };
    if (truthyWord(s)) return { active: true, names: [] };
    if (falsyWord(s)) return { active: false, names: [] };
    const names = s
      .split(',')
      .map((t) => t.trim())
      .filter(Boolean);
    return { active: names.length > 0, names };
  };
  const parseCustomizationRaw = (raw) => {
    const s = (raw || '').toString().trim();
    if (!s) return { active: false, groups: [] };
    if (truthyWord(s)) return { active: true, groups: [] };
    if (falsyWord(s)) return { active: false, groups: [] };
    const groups = s
      ?.split('/')
      ?.map((t) => t.trim())
      ?.filter(Boolean);
    return { active: true, groups };
  };
  const toLowerSet = (arr) => new Set((arr || []).map((x) => x.toString().trim().toLowerCase()));
  const handleCsvFileData = (itemsLists) => {
    const isTemplateInstructionRow = (row) => {
      const values = Object.values(row).map((v) => String(v || '').toLowerCase().trim());
      const joined = values.join(' ');
      const instructionPatterns = [
        'character limit', 'mandatory', 'alphanumeric', 'alpha-numeric',
        'enter the', 'fill in', 'e.g.', 'example:', 'max characters',
        'max char', 'required field', 'this field', 'drop down', 'dropdown',
        'select from', 'free text', 'auto populate', 'auto-populate',
      ];
      if (values.some((s) => s.startsWith('*') && instructionPatterns.some((p) => s.includes(p)))) return true;
      if (instructionPatterns.filter((p) => joined.includes(p)).length >= 2) return true;
      return false;
    };
    const filteredItemList = itemsLists.filter((row) => !isTemplateInstructionRow(row));
    const errors = [];
    if (filteredItemList.length === 0) {
      errors.push('No data rows found in the uploaded file.');
      setValidationErrors(errors);
      setCsvValidateError(true);
      return;
    }
    const tagSet = toLowerSet(originalTags?.map((x) => x.name));
    const allergenSet = toLowerSet(originalAllergens?.map((x) => x.name));
    const addonSet = toLowerSet(originalAddons?.map((x) => x.name));
    const discountSet = toLowerSet(originalDiscounts?.map((x) => x.name));
    const customSet = toLowerSet(originalCustomisations?.map((x) => x.name));
    filteredItemList.forEach((item) => {
      const rowNum = item.__rowNum || '?';
      const rowErrors = [];
      if (!item.itemName?.trim()) {
        rowErrors.push('"Item Name" is empty');
      } else {
        if (item.itemName.trim().length > 150) rowErrors.push('"Item Name" exceeds 150 characters');
      }
      if (!item.itemCode?.trim()) {
        rowErrors.push('"Item Code" is empty');
      } else {
        if (item.itemCode.trim().length > 1000) rowErrors.push('"Item Code" exceeds 1000 characters');
        if (!validateAlphanumeric(item.itemCode.trim())) rowErrors.push('"Item Code" must be alphanumeric');
      }
      if (!item.itemType?.trim()) {
        rowErrors.push('"Item Type" is empty');
      } else if (!inRoomDiningKinds.find((x) => x.name.toLowerCase() === item.itemType.trim().toLowerCase())) {
        rowErrors.push(`"Item Type" '${item.itemType.trim()}' is not valid (allowed: ${inRoomDiningKinds.map((x) => x.name).join(', ')})`);
      }
      const priceNum = parseFloat(String(item?.itemPrice ?? '').trim());
      if (!item.itemPrice?.toString()?.trim()) {
        rowErrors.push('"Item Price" is empty');
      } else if (isNaN(priceNum) || priceNum < 1) {
        rowErrors.push('"Item Price" must be a valid number >= 1');
      }
      if (item.ingredients?.trim() && item.ingredients.trim().length > 350) {
        rowErrors.push('"Ingredients" exceeds 350 characters');
      }
      if (item.tagsName?.trim()) {
        const names = item.tagsName.split(',').map((s) => s.trim()).filter(Boolean);
        const unknown = names.filter((n) => !tagSet.has(n.toLowerCase()));
        if (unknown.length > 0) rowErrors.push(`"Tags" not found in system: ${unknown.join(', ')}`);
      }
      if (item.allergensName?.trim()) {
        const names = item.allergensName.split(',').map((s) => s.trim()).filter(Boolean);
        const unknown = names.filter((n) => !allergenSet.has(n.toLowerCase()));
        if (unknown.length > 0) rowErrors.push(`"Allergens" not found in system: ${unknown.join(', ')}`);
      }
      if (item.addOns?.trim()) {
        const addOnTypeVal = (item?.addOnType || '').toString().trim().toLowerCase();
        const rawAddons = item.addOns.trim();
        if (addOnTypeVal === 'grouped') {
          const groups = rawAddons.split('/').map((s) => s.trim()).filter(Boolean);
          groups.forEach((g) => {
            const parts = g.split('-');
            if (parts.length !== 3) {
              rowErrors.push(`"Add-Ons" grouped format invalid: '${g}' (expected: title-limit-addon1,addon2)`);
            } else {
              const listStr = (parts[2] || '').trim();
              const names = listStr.split(',').map((s) => s.trim()).filter(Boolean);
              const unknown = names.filter((n) => !addonSet.has(n.toLowerCase()));
              if (unknown.length > 0) rowErrors.push(`"Add-Ons" not found in system: ${unknown.join(', ')}`);
            }
          });
        } else if (addOnTypeVal === 'ungrouped') {
          let addonNames = [];
          if (rawAddons.includes('-')) {
            const parts = rawAddons.split('-');
            const listStr = (parts[1] || '').trim();
            addonNames = listStr.split(',').map((s) => s.trim()).filter(Boolean);
          } else {
            addonNames = rawAddons.split(',').map((s) => s.trim()).filter(Boolean);
          }
          const unknown = addonNames.filter((n) => !addonSet.has(n.toLowerCase()));
          if (unknown.length > 0) rowErrors.push(`"Add-Ons" not found in system: ${unknown.join(', ')}`);
        }
      }
      if (item.customization?.trim()) {
        const customInfo = parseCustomizationRaw(item.customization);
        if (customInfo.groups.length > 0) {
          customInfo.groups.forEach((g) => {
            const parts = String(g || '').split('-');
            const listStr = (parts[1] || '').trim();
            if (listStr) {
              const names = listStr.split(',').map((s) => s.trim()).filter(Boolean);
              const unknown = names.filter((n) => !customSet.has(n.toLowerCase()));
              if (unknown.length > 0) rowErrors.push(`"Customisation" not found in system: ${unknown.join(', ')}`);
            }
          });
        }
      }
      if (item.upsell?.trim()) {
        const upsellInfo = asBooleanOrList(item.upsell);
        if (upsellInfo.names.length > 0) {
          const existingItemSet = toLowerSet(itemsList?.map((x) => x.name));
          const unknown = upsellInfo.names.filter((n) => !existingItemSet.has(n.toLowerCase()));
          if (unknown.length > 0) rowErrors.push(`"Upsell" items not found in system: ${unknown.join(', ')}`);
        }
      }
      if (item.discount?.trim()) {
        const discountInfo = asBooleanOrList(item.discount);
        if (discountInfo.names.length > 0) {
          const unknown = discountInfo.names.filter((n) => !discountSet.has(n.toLowerCase()));
          if (unknown.length > 0) rowErrors.push(`"Discount" not found in system: ${unknown.join(', ')}`);
        }
      }
      if (item.active?.trim() && !isValidStatus(item.active)) rowErrors.push('"Active" must be Yes or No');
      if (rowErrors.length > 0) errors.push(`Row ${rowNum}: ${rowErrors.join(', ')}`);
    });
    if (errors.length > 0) {
      setValidationErrors(errors);
      setCsvValidateError(true);
      return;
    }
    const duplicateErrors = [];
    const newItems = filteredItemList.filter((item) => {
      const nameExists = itemsList?.findIndex((ch) => ch?.name?.trim()?.toLowerCase() === item?.itemName?.trim()?.toLowerCase()) > -1;
      const codeExists = itemsList?.findIndex((ch) => ch?.code?.trim()?.toLowerCase() === item?.itemCode?.trim()?.toLowerCase()) > -1;
      if (nameExists || codeExists) {
        const rowNum = item.__rowNum || '?';
        const reasons = [];
        if (nameExists) reasons.push(`name '${item.itemName.trim()}'`);
        if (codeExists) reasons.push(`code '${item.itemCode.trim()}'`);
        duplicateErrors.push(`Row ${rowNum}: Already exists (${reasons.join(' and ')})`);
        return false;
      }
      return true;
    });
    if (duplicateErrors.length > 0) duplicateErrors.forEach((e) => errors.push(e));
    if (newItems.length === 0) {
      setValidationErrors(errors);
      setCsvValidateError(true);
      setDataExistError(duplicateErrors.length > 0);
      return;
    }
    const listToUpload = newItems.map((item) => {
      const upsellInfo = asBooleanOrList(item?.upsell);
      const discountInfo = asBooleanOrList(item?.discount);
      const customizationInfo = parseCustomizationRaw(item?.customization);
      const tagSet = toLowerSet(originalTags?.map((x) => x.name));
      const allergenSet = toLowerSet(originalAllergens?.map((x) => x.name));
      const discountSet = toLowerSet(originalDiscounts?.map((x) => x.name));
      const addonSet = toLowerSet(originalAddons?.map((x) => x.name));
      const customSet = toLowerSet(originalCustomisations?.map((x) => x.name));
      const existingItemSet = toLowerSet(itemsList?.map((x) => x.name));
      const filterKnown = (namesArr, knownSet) =>
        (namesArr || [])
          ?.map((s) => s && s?.toString()?.trim())
          ?.filter(Boolean)
          ?.filter((n) => knownSet?.has(n?.toLowerCase()));
      const priceNum = parseFloat(String(item?.itemPrice ?? '').trim());
      const payload = {
        hotelId,
        code: item?.itemCode,
        name: item?.itemName,
        price: priceNum,
        description: item?.description,
        ingredients: item?.ingredients,
        status: truthyWord(item?.active),
        tags: originalTags
          .filter((x) => toLowerSet((item?.tagsName || '')?.split(','))?.has(x.name?.toLowerCase()))
          .map((e) => e.id),
        allergens: originalAllergens
          .filter((x) =>
            toLowerSet((item?.allergensName || '')?.split(','))?.has(x?.name?.toLowerCase()),
          )
          .map((e) => e.id),
        type: inRoomDiningKinds?.find(
          (x) =>
            x.name?.toLowerCase() === (item?.itemType || '')?.toString()?.trim()?.toLowerCase(),
        )?.id,
        addons: {},
        upsell: { status: false, items: [] },
        discount: { status: false, discount: [] },
        customisation: {},
        restaurantId,
      };
      const addOnTypeRaw = (item?.addOnType || '').toString().trim().toLowerCase();
      const addOnsRaw = (item?.addOns || '').toString().trim();
      if (addOnTypeRaw === 'grouped') {
        const groups = addOnsRaw
          ?.split('/')
          ?.map((s) => s?.trim())
          ?.filter(Boolean);
        const groupedAddon = [];
        for (const g of groups) {
          const parts = g.split('-');
          if (parts.length !== 3) continue;
          const title = (parts[0] || '').trim();
          const limitStr = (parts[1] || '').trim();
          const listStr = (parts[2] || '').trim();
          if (!title || !validateAlphanumeric(title)) continue;
          const chosenNames = filterKnown(
            listStr.split(',').map((s) => s.trim()),
            addonSet,
          );
          if (chosenNames.length === 0) continue;
          const limitNum = Math?.max(
            1,
            Math?.min(parseInt(limitStr, 10) || chosenNames.length, chosenNames.length),
          );
          const ids = originalAddons
            ?.filter((x) => chosenNames?.includes(x.name))
            ?.map((e) => e.id);
          groupedAddon?.push({
            title,
            limit: limitNum,
            addons: ids,
          });
        }
        if (groupedAddon.length > 0) {
          payload.addons.type = IN_ROOM_DINING_COMBO_ADDONS_GROUPED;
          payload.addons.groupedAddon = groupedAddon;
        } else {
          payload.addons.type = IN_ROOM_DINING_COMBO_ADDONS_INACTIVE;
          payload.addons.limit = false;
        }
      } else if (addOnTypeRaw === 'ungrouped') {
        if (addOnsRaw.includes('-')) {
          const parts = addOnsRaw.split('-');
          const limitStr = (parts[0] || '').trim();
          const listStr = (parts[1] || '').trim();

          const chosenNames = filterKnown(
            listStr.split(',').map((s) => s.trim()),
            addonSet,
          );
          if (chosenNames.length > 0) {
            const ids = originalAddons.filter((x) => chosenNames.includes(x.name)).map((e) => e.id);
            const limitNum = Math.max(
              1,
              Math.min(parseInt(limitStr, 10) || chosenNames.length, ids.length),
            );
            payload.addons = {
              type: IN_ROOM_DINING_COMBO_ADDONS_UNGROUPED,
              addons: ids,
              limit: true,
              value: limitNum,
            };
          } else {
            payload.addons.type = IN_ROOM_DINING_COMBO_ADDONS_INACTIVE;
            payload.addons.limit = false;
          }
        } else {
          const chosenNames = filterKnown(
            addOnsRaw.split(',').map((s) => s.trim()),
            addonSet,
          );

          if (chosenNames.length > 0) {
            const ids = originalAddons.filter((x) => chosenNames.includes(x.name)).map((e) => e.id);

            payload.addons = {
              type: IN_ROOM_DINING_COMBO_ADDONS_UNGROUPED,
              addons: ids,
              limit: false,
              value: null,
            };
          } else {
            payload.addons.type = IN_ROOM_DINING_COMBO_ADDONS_INACTIVE;
            payload.addons.limit = false;
          }
        }
      } else {
        payload.addons.type = IN_ROOM_DINING_COMBO_ADDONS_INACTIVE;
        payload.addons.limit = false;
      }
      const upsellNames = filterKnown(upsellInfo.names, existingItemSet);
      const upsellIds =
        upsellNames.length > 0
          ? itemsList?.filter((x) => upsellNames?.includes(x.name))?.map((e) => e.id)
          : [];
      payload.upsell = {
        status: upsellIds.length > 0,
        items: upsellIds,
      };
      const discountNames = filterKnown(discountInfo.names, discountSet);
      const discountIds =
        discountNames.length > 0
          ? originalDiscounts?.filter((x) => discountNames?.includes(x.name))?.map((e) => e.id)
          : [];
      payload.discount = {
        status: discountIds.length > 0,
        discount: discountIds,
      };
      if (customizationInfo.groups.length > 0) {
        const groupsOut = [];
        for (const g of customizationInfo.groups) {
          const [ingredientRaw, listStrRaw] = String(g || '').split('-');
          const ingredient = (ingredientRaw || '').trim();
          const listStr = (listStrRaw || '').trim();
          if (!ingredient || ingredient.length > 100 || !validateAlphanumeric(ingredient)) continue;
          const chosenNames = filterKnown(
            listStr.split(',').map((s) => s.trim()),
            customSet,
          );
          if (chosenNames.length === 0) continue;
          const ids = originalCustomisations
            ?.filter((x) => chosenNames.includes(x.name))
            ?.map((e) => e.id);
          groupsOut?.push({ ingredient, customisations: ids });
        }
        if (groupsOut.length > 0) {
          payload.customisation.status = true;
          payload.customisation.ingredients = groupsOut;
        } else {
          payload.customisation.status = false;
          payload.customisation.ingredients = [];
        }
      } else {
        payload.customisation.status = false;
        payload.customisation.ingredients = [];
      }
      return payload;
    });
    setValidationErrors([]);
    setCsvValidateError(false);
    setDataExistError(false);
    handleCsvDataSubmit(listToUpload);
  };

  const generateAddonsData = (addons, type) => {
    const t = String(type)?.toLowerCase();
    const groupedKey = String(IN_ROOM_DINING_COMBO_ADDONS_GROUPED)?.toLowerCase();
    const ungroupedKey = String(IN_ROOM_DINING_COMBO_ADDONS_UNGROUPED)?.toLowerCase();

    if (t === groupedKey) {
      return addons?.groupedAddon
        ?.map(
          (x) =>
            `${x.title}-${x.limit}-${originalAddons
              .filter((e) => x.addons.includes(e.id))
              .map((e) => e.name.toLowerCase())
              .toString()}`,
        )
        .toString();
    } else if (t === ungroupedKey) {
      if (addons?.limit) {
        return `${addons.value}-${originalAddons
          .filter((e) => addons.addons.includes(e.id))
          .map((e) => e.name.toLowerCase())
          .toString()}`;
      } else {
        return `${originalAddons
          .filter((e) => addons.addons.includes(e.id))
          .map((e) => e.name.toLowerCase())
          .toString()}`;
      }
    }
    return '';
  };

  const generateCustomizationData = (customizationData) => {
    if (customizationData?.status) {
      return customizationData?.ingredients
        ?.map(
          (x) =>
            `${x.ingredient}-${originalCustomisations
              .filter((e) => x.customisations.includes(e.id))
              .map((e) => e.name.toLowerCase())
              .toString()}`,
        )
        .toString();
    }
  };

  const generateHeaders = [
    { label: 'Item Type', key: 'itemType' },
    { label: 'Item Name', key: 'name' },
    { label: 'Item Code', key: 'code' },
    { label: 'Description', key: 'description' },
    { label: 'Active', key: 'active' },
    { label: 'Item Price', key: 'price' },
    { label: 'Ingredients', key: 'ingredients' },
    { label: 'Allergens Name', key: 'allergensName' },
    { label: 'Tags Name', key: 'tagsName' },
    { label: 'Add On Type', key: 'addOnType' },
    { label: 'Add ons', key: 'addOns' },
    { label: 'Customization', key: 'customizations' },
    { label: 'Upsell', key: 'upsells' },
    { label: 'Discount', key: 'itemDiscount' },
  ];

  const generateExportData = (itemsData) => {
    return itemsData
      ?.map((item) => {
        const activeStatus = item?.status ? 'YES' : 'NO';
        const rawAddOnType = item?.addons?.type;
        const addOnType = String(rawAddOnType)?.toLowerCase();
        const addOns = generateAddonsData(item?.addons, rawAddOnType) || '';
        const upsells = item.upsell.status
          ? itemsList
              .filter((x) => item.upsell.items.includes(x.id))
              .map((e) => e.name.toLowerCase())
              .join(',')
          : '';
        const itemType = inRoomDiningKinds.find((x) => x.id === item.type)?.name || '';
        const allergensName = item.allergens
          ? originalAllergens
              .filter((x) => item.allergens.includes(x.id))
              .map((e) => e.name.toLowerCase())
              .join(',')
          : '';
        const tagsName = item.tags
          ? originalTags
              .filter((x) => item.tags.includes(x.id))
              .map((e) => e.name.toLowerCase())
              .join(',')
          : '';
        const itemDiscount = item.discount.status
          ? originalDiscounts
              .filter((x) => item.discount?.discount?.includes(x.id))
              .map((e) => e.name.toLowerCase())
              .join(',')
          : '';
        const customizations = generateCustomizationData(item?.customisation) || '';

        return {
          itemType: `"${itemType}"`,
          name: `"${item.name}"`,
          code: `"${item.code}"`,
          description: `"${item.description}"`,
          active: `"${activeStatus}"`,
          price: `"${item.price}"`,
          ingredients: `"${item.ingredients}"`,
          allergensName: `"${allergensName}"`,
          tagsName: `"${tagsName}"`,
          addOnType: `"${addOnType}"`,
          addOns: `"${addOns}"`,
          customizations: `"${customizations}"`,
          upsells: `"${upsells}"`,
          itemDiscount: `"${itemDiscount}"`,
        };
      })
      ?.map((record) =>
        Object?.fromEntries(
          Object?.entries(record)?.filter(([key]) =>
            [
              'itemType',
              'name',
              'code',
              'description',
              'active',
              'price',
              'ingredients',
              'allergensName',
              'tagsName',
              'addOnType',
              'addOns',
              'customizations',
              'upsells',
              'itemDiscount',
            ]?.includes(key),
          ),
        ),
      );
  };

  const handleExport = () => {
    let selectedValue = itemsList?.filter((item) => item?.isChecked);
    let exportData = [];
    let csvName = '';

    const propertyName = selectedHotel?.find((value) => value?.id === hotelId)?.name;

    if (selectedValue?.length === 1) {
      csvName = `${selectedValue[0].name}_ird_item.csv`;
      exportData = generateExportData(selectedValue);
    } else if (selectedValue?.length > 1) {
      csvName = `${propertyName}_ird_items.csv`;
      exportData = generateExportData(selectedValue);
    } else {
      csvName = `${propertyName}_ird_items.csv`;
      exportData = generateExportData(itemsList);
    }

    const headers = generateHeaders?.map((header) => header?.label);
    const csvContent = [
      headers.join(','),
      ...exportData?.map((item) =>
        generateHeaders?.map((header) => item[header.key] || '').join(','),
      ),
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const anchor = document.createElement('a');
    anchor.href = window.URL.createObjectURL(blob);
    anchor.download = csvName;

    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  useEffect(() => {
    updateSelectedModule(itemsList, setActionMenuList, setIsAllSelected);
  }, [itemsList]);

  useEffect(() => {
    if (loading || itemsList?.length === 0) return;
    const totalItems = itemsList?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [itemsList?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== hotelId) {
      onsetPage(0);
      resetFilterDataList();
    }
    prevHotelIdRef.current = hotelId;
  }, [hotelId]);

  const handleAction = (actionName) => {
    let selectedDiscount = itemsList?.filter((item) => item?.isChecked);
    switch (actionName) {
      case 'Delete':
        if (selectedDiscount?.length > 0) {
          setShowMultipleDeleteConfirmation(true);
          setActionName('delete');
        }
        break;
      case 'Activate':
        if (selectedDiscount?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('activate');
          setIsActive(true);
        }
        break;
      case 'Deactivate':
        if (selectedDiscount?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('deactivate');
          setIsActive(false);
        }
        break;
      case 'Export':
        if (selectedDiscount?.length > 0) {
          handleExport();
        }
        break;
      default:
        break;
    }
  };

  const handleCheckboxChange = (id) => {
    let actionListName = [];
    let index = itemsList?.findIndex((item) => item.id === id);
    if (!itemsList[index]?.isChecked) {
      itemsList[index] = { ...itemsList[index], isChecked: true };
    } else {
      itemsList[index].isChecked = !itemsList[index]?.isChecked;
    }
    setItemsList([...itemsList]);

    let actionList = itemsList?.filter((item) => item?.isChecked)?.map((status) => status?.status);

    const checkedItems = itemsList?.filter((item) => item?.isChecked);

    if (checkedItems.length === 0) {
      setActionMenuList([]);
      setIsAllSelected(false);
      return;
    }

    const isActiveSelected = actionList.includes(true);
    const isInactiveSelected = actionList.includes(false);

    if (isActiveSelected && isInactiveSelected) {
      actionListName.push('Activate', 'Deactivate');
    } else if (isActiveSelected) {
      actionListName.push('Deactivate');
    } else if (isInactiveSelected) {
      actionListName.push('Activate');
    }
    if (!actionListName.includes('Export')) {
      actionListName.push('Export');
    }

    const isAllSelected = itemsList?.every((item) => item?.isChecked);
    setIsAllSelected(isAllSelected);

    setActionMenuList(actionListName);
  };

  const handleSelectAll = (event) => {
    let actionListName = [];
    const CheckedValue = event?.target?.checked;
    setIsAllSelected(CheckedValue);
    let selectedItemList = itemsList?.map((item) => {
      return {
        ...item,
        isChecked: CheckedValue,
      };
    });

    const isActive = selectedItemList?.some((item) => item?.status);
    const isInactive = selectedItemList?.some((item) => !item.status);

    if (isActive && !actionListName?.includes('Deactivate')) {
      actionListName.push('Deactivate');
    }
    if (isInactive && !actionListName?.includes('Activate')) {
      actionListName.push('Activate');
    }
    if (!actionListName.includes('Export')) {
      actionListName.push('Export');
    }

    setItemsList([...selectedItemList]);

    const sortActionMenuList = actionListName.sort((a, b) => {
      const order = { Activate: 1, Deactivate: 2, Delete: 3 };
      return order[a] - order[b];
    });

    setActionMenuList(sortActionMenuList);

    if (!event?.target?.checked && !selectedItemList.some((item) => item?.isChecked)) {
      setActionMenuList([]);
    }
  };

  const onApiCallConfirmationNotification = generateConfirmationMessage(
    'Item',
    listOfItemIds?.length,
    isActive,
  );

  const handleMultipleStatusChange = async () => {
    handleClose();
    setActionMenuList([]);
    try {
      dispatch(stepUpLoaderCount());
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'IRD_ITEM';
      await updateSelectedItemsStatus(
        listOfItemIds,
        hotelId,
        selectedLang,
        moduleName,
        restaurantId,
        isActive,
        searchText.length > 0 ? false : isAllSelected,
      );
      dispatch(fetchAllInRoomDining(hotelId, restaurantId));
      notificationManager('success', onApiCallConfirmationNotification);
      setSelectedValue({
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        activate: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'The status of the Item was not changed',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }

    setIsAllSelected(false);
  };

  const deleteMultipleSelection = async () => {
    handleClose();
    try {
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'IRD_ITEM';
      await deleteSelectedItems(
        listOfItemIds,
        hotelId,
        selectedLang,
        moduleName,
        restaurantId,
        searchText.length > 0 ? false : isAllSelected,
      );
      dispatch(fetchAllInRoomDining(hotelId, restaurantId));
      notificationManager('success', 'Items deleted successfully');
      setSelectedValue({
        ...selectedValue,
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Item Deletion Failed',
      );
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const handleCsvDataSubmit = async (payloadLists) => {
    setCsvUploadStatus('uploading');
    try {
      dispatch(stepUpLoaderCount());
      const payload = {
        isReplace: false,
        hotelId: hotelId,
        items: payloadLists,
        restaurantId,
      };
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      const res = await uploadIRDItemByCSV(payload, language);
      if (res?.data?.uploadIRDItemsByCSV?.status === 'Success') {
        setCsvUploadStatus('success');
      } else {
        setCsvUploadStatus('error');
      }
    } catch (e) {
      setCsvUploadErrorMsg(null);
      setCsvUploadStatus('server-error');
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  // useEffect(() => {
  //   let isFilterButtonSelected = filterDataList?.find((filterDataList) =>
  //     filterDataList?.subMenu?.find((subMenuItem) => subMenuItem?.selected)
  //   );
  //   if (isFilterButtonSelected) {
  //     setIsAllSelected(false);
  //   }
  // }, [filterDataList]);

  return (
    <div className='mt-4 mb-4 group-list-container'>
      <Dialog fullScreen open={uploadState} onClose={handleUploadDialogClose}>
        <CsvUploader
          onClose={handleUploadDialogClose}
          pageTitle='Items'
          onFileReadingComplete={(e) => handleCsvFileData(e)}
          csvUploadStatus={csvUploadStatus}
          validFormatError={csvValidateError}
          setValidFormatError={setCsvValidateError}
          dataExistError={dataExistError}
          setDataExistError={setDataExistError}
          listName='Items'
          sectionTItle='Menu Configuration'
          csvUploadErrorMsg={csvUploadErrorMsg}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
          downloadLink={DOWNLOAD_ASSETS_URL + '/cmsAssets/Menu+Configs+-+Items.xlsx'}
        />
      </Dialog>
      {selectedValue.id && selectedValue.status === true && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={onDeleteItem}
          onDeleteCancel={onDeleteCancel}
        />
      )}
      {selectedValue.id && selectedValue.warn && (
        <WarningPopup warningPopup={selectedValue} onWarningClose={handleClose} warn={true} />
      )}
      <SearchBar
        type={IN_ROOM_DINING_ITEMS_CREATE}
        buttonName='Add Item'
        onOpenDrawer={onOpenDrawer}
        setSearchText={handleSearchText}
        filterList={filterDataList}
        setFilterDataList={setFilterDataList}
        filteredRecoard={filteredRecords}
        displayAddOrEdit={
          permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
            ? !isHideAddButton
              ? 'show'
              : 'hide'
            : 'hide'
        }
        visible={visible}
        setVisible={setVisible}
        popUp={popUp}
        setPopUp={setPopUp}
        placeHolder={itemsList}
        setPlaceHolder={setItemsList}
        globalPlaceHolder={inRoomDiningItems}
        setGlobalPlaceHolder={setInRoomDiningItems}
        dispatch={dispatch}
        mappingApi={createDataSortMapping}
        displayText='In-Room dining items'
        module='IRD_ITEM'
        searchText={searchText}
        setSearch={setSearchText}
        extraSecondaryBtnDisplay={
          permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
        }
        extraSecondaryBtnText='Upload'
        onClickSecondaryBtn={onClickUpload}
        //temporary disable
        // exportBtn
        // exportBtnTitle="Export"
        // headers={generateHeaders}
        // exportData={generateExportData(itemsList)}
        actionMenuItems={actionMenuList ?? []}
        handleAction={handleAction ?? false}
        setDrag={setDragEnabled}
      />
      <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
        {loading ? (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        ) : (
          itemsList && (
            <TableContainer>
              <Table className='list-table' aria-label='simple table'>
                <TableHead>
                  <TableRow>
                    <TableCell className={`w-5 ${dragDisabled ? '' : 'ps-5'}`}>
                      <BulkActionCheckBox
                        onChange={handleSelectAll}
                        checked={isAllSelected || false}
                        selectedLength={selectedDiscountLength}
                        totalLength={inRoomDiningItems?.length}
                        inputProps={{
                          'aria-label': 'select all Items',
                        }}
                        className={PARTIAL_CHECKBOX_GREEN}
                      />
                    </TableCell>
                    <TableCell className='w-30'>Name</TableCell>
                    <TableCell className='w-20'>Type</TableCell>
                    <TableCell className='w-20' align='right'>
                      Item Price
                    </TableCell>
                    <TableCell className='w-30' align='center'>
                      Status
                    </TableCell>
                    <TableCell align='right'></TableCell>
                  </TableRow>
                </TableHead>

                <DragDropContext
                  onDragEnd={(event) =>
                    handleOnDragEnd(
                      event,
                      setVisible,
                      itemsList,
                      setItemsList,
                      false,
                      page,
                      rowsPerPage,
                    )
                  }
                  isDropDisabled={dragDisabled}
                >
                  <Droppable droppableId='services' isDropDisabled={dragDisabled}>
                    {(provided) => (
                      <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                        {(rowsPerPage > 0
                          ? itemsList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          : itemsList
                        ).map((itemKey, i) => (
                          <Draggable
                            key={itemKey.id}
                            draggableId={itemKey.id}
                            index={i}
                            isDragDisabled={dragDisabled}
                          >
                            {(provided) => (
                              <TableRow
                                key={i}
                                className='border-white pointer'
                                onClick={(e) => {
                                  onViewDetails(itemKey, e);
                                }}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <TableCell className='w-12'>
                                  {!dragDisabled && (
                                    <span style={{ marginRight: 1.5 }}>
                                      <DragIndicator className='res-menu-accordion-drag' />
                                    </span>
                                  )}
                                  <Checkbox
                                    onChange={(event) => handleCheckboxChange(itemKey?.id)}
                                    checked={itemKey?.isChecked || false}
                                    inputProps={{
                                      'aria-label': `select item ${itemKey?.id}`,
                                    }}
                                  />
                                </TableCell>
                                <TableCell className='w-30'>{itemKey?.name}</TableCell>
                                <TableCell className='w-20'>{getItemType(itemKey?.type)}</TableCell>
                                <TableCell className='w-20' align='right'>
                                  {currency + ' '}
                                  {itemKey?.price}
                                </TableCell>
                                <TableCell className='w-30' align='center'>
                                  <CustomChip
                                    label={itemKey?.status ? 'Active' : 'Inactive'}
                                    color={itemKey?.status ? 'primary' : 'default'}
                                  />
                                </TableCell>
                                <TableCell align='right' className='kebab-menu'>
                                  {permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] ===
                                    RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                                    <Button
                                      aria-controls='simple-menu'
                                      aria-haspopup='true'
                                      onClick={(e) => {
                                        handleCellMenuClick(e, itemKey);
                                      }}
                                      className='showpopupInner'
                                    >
                                      <MoreHoriz className='showpopupInner' />
                                    </Button>
                                  )}
                                  <Menu
                                    id={itemKey.id}
                                    anchorEl={selectedValue?.anchorEl}
                                    disableRestoreFocus
                                    MenuListProps={{ autoFocusItem: false }}
                                    keepMounted
                                    open={
                                      Boolean(selectedValue.anchorEl) &&
                                      selectedValue.id === itemKey.id
                                    }
                                    onClose={handleClose}
                                    className='shadow'
                                  >
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onToggleStatus(e);
                                      }}
                                    >
                                      {selectedValue.item && selectedValue.item.status ? (
                                        <>
                                          <RemoveCircleIcon className='me-2 action-menu-icon' />
                                          Deactivate
                                        </>
                                      ) : (
                                        <>
                                          <AddCircle className='me-2 action-menu-icon' />
                                          Activate
                                        </>
                                      )}
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onOpenDrawer(e, IN_ROOM_DINING_ITEMS_EDIT);
                                      }}
                                    >
                                      <CreateIcon className='me-2 action-menu-icon' />
                                      Edit
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onViewDetailsFromMenu(e);
                                      }}
                                    >
                                      <VisibilityIcon className='me-2 action-menu-icon' />
                                      View
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onClickDelete(e);
                                      }}
                                    >
                                      <DeleteForeverIcon className='me-2 action-menu-icon' />
                                      Delete
                                    </MenuItem>
                                  </Menu>
                                </TableCell>
                              </TableRow>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </TableBody>
                    )}
                  </Droppable>
                </DragDropContext>
                <TableFooter>
                  <TableRow className='paginator'>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                      count={itemsList.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: { 'aria-label': 'rows per page' },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )
        )}{' '}
        {showMultipleDeleteConfirmation && (
          <MultipleDeleteConfirmationPopup
            title={`Are you sure you want to ${actionName} this selection?`}
            subTitle={`A selection of ${selectedDiscountLength} ${
              selectedDiscountLength > 1 ? 'items' : 'item'
            } will be ${actionName}d. This Action is irreversible.`}
            isOpen={showMultipleDeleteConfirmation}
            onClose={() => setShowMultipleDeleteConfirmation(false)}
            onConfirm={() => {
              deleteMultipleSelection();
            }}
            leftButtonName={'Cancel'}
            rightButtonName={'Delete'}
          />
        )}
        {showBulkActiveDeactiveConfirmation && (
          <MultipleDeleteConfirmationPopup
            title={`Are you sure you want to ${actionName} this selection?`}
            subTitle={`A selection of ${selectedDiscountLength}  ${
              selectedDiscountLength > 1 ? 'items' : 'item'
            } will be ${actionName}d.`}
            isOpen={showBulkActiveDeactiveConfirmation}
            onClose={() => setShowBulkActiveDeactiveConfirmation(false)}
            onConfirm={() => {
              handleMultipleStatusChange();
            }}
            leftButtonName={'No'}
            rightButtonName={'Yes'}
          />
        )}{' '}
        {showBulkSearchAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkSearchAlert}
            onClose={handleBulkSearchAlertClose}
            message="If you perform a search after making selections, the items you've selected will be lost."
            ButtonName='Cancel'
          />
        )}
        {showBulkKebabSelectionAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkKebabSelectionAlert}
            onClose={() => setShowBulkKebabSelectionAlert(false)}
            message='Please select one item from the list that you want to edit.'
            centerButtonName='OK'
          />
        )}
        {showBulkFilterAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkFilterAlert}
            onClose={() => setShowBulkFilterAlert(false)}
            message="If you perform a filter after making selections, the items you've selected will be lost."
            ButtonName='Cancel'
          />
        )}
      </div>
    </div>
  );
};

export default ItemsListView;
